import { render, staticRenderFns } from "./Allergie.vue?vue&type=template&id=596dc350"
import script from "./Allergie.vue?vue&type=script&lang=js"
export * from "./Allergie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports